export const formatUnitCode = (templateCode: string, seq: number, padding = 4) =>
  `${templateCode}-${String(seq).padStart(padding, '0')}`;

/** @deprecated Use formatUnitCode */
export const formatInstanceNumber = formatUnitCode;

export interface ParsedInstanceNumber {
  prefix: string;
  suffix: number | null;
  raw: string;
}

export const parseInstanceNumber = (value: string): ParsedInstanceNumber => {
  const raw = value.trim();
  const m = raw.match(/^(.*-)(\d+)$/);
  if (!m) return { prefix: '', suffix: null, raw };
  return { prefix: m[1], suffix: parseInt(m[2], 10), raw };
};

export const compareInstanceNumbers = (a: string, b: string): number => {
  const pa = parseInstanceNumber(a);
  const pb = parseInstanceNumber(b);
  if (pa.prefix === pb.prefix && pa.suffix != null && pb.suffix != null) {
    return pa.suffix - pb.suffix;
  }
  return pa.raw.localeCompare(pb.raw, undefined, { numeric: true, sensitivity: 'base' });
};

export const isInInstanceRange = (value: string, from: string, to: string): boolean => {
  const v = parseInstanceNumber(value);
  const f = parseInstanceNumber(from.trim());
  const t = parseInstanceNumber(to.trim());
  if (v.prefix && f.prefix && t.prefix && v.prefix !== f.prefix) return false;
  if (v.suffix != null && f.suffix != null && t.suffix != null) {
    return v.suffix >= f.suffix && v.suffix <= t.suffix;
  }
  return compareInstanceNumbers(value, from) >= 0 && compareInstanceNumbers(value, to) <= 0;
};
